import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { toast } from 'sonner';
import { FakeForm } from '../../../../features/users/components/fake-form';
import { useCreateFake } from '../../../../features/users/mutations';
import { PageHeader } from '../../../../shared/components/page-header';

export const Route = createFileRoute('/_authenticated/users/fakes/new')({
  component: NewFakePage,
});

function NewFakePage() {
  const navigate = useNavigate();
  const create = useCreateFake();
  return (
    <div className="space-y-6">
      <PageHeader title="Новый фейк" />
      <FakeForm
        submitLabel="Создать"
        onSubmit={async (values) => {
          try {
            const created = await create.mutateAsync(values);
            toast.success('Фейк создан');
            navigate({ to: '/users/fakes/$fakeId', params: { fakeId: created.id } });
          } catch (err) {
            toast.error((err as Error).message);
          }
        }}
      />
    </div>
  );
}
